// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"78":"f05f596b","261":"f25618ab","338":"7f897098","456":"e96dc76a","541":"989fa201","544":"89d48519","576":"669b865d","753":"73ab05ac","775":"918d4dee","823":"85685b95","980":"61b6d15b"}[chunkId] + ".js";
};